import { render, staticRenderFns } from "./MPopupWelcome.vue?vue&type=template&id=4e648035&"
import script from "./MPopupWelcome.vue?vue&type=script&lang=ts&"
export * from "./MPopupWelcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports